import { useTranslation } from "react-i18next";

export const useMockDataHTPP = () => {
  const { t } = useTranslation();
  return [
    {
      id: "userAgent",
      attribute: t("scannerFingerprint.HTTP.userAgent"),
      ratio: 0.34,
      value: "-",
      clue: t("scannerFingerprint.HTTP.userAgentClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.HTTP.accept"),
      ratio: 17.09,
      value:
        "text/html,application/xhtml+xml, application/xml;q=0.9,image/avif, image/webp,image/apng, */*;q=0.8,application/signed-exchange; v=b3;q=0.7",
      clue: t("scannerFingerprint.HTTP.acceptClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.HTTP.contentEncoding"),
      ratio: 8.62,
      value: "gzip, deflate",
      clue: t("scannerFingerprint.HTTP.contentEncodingClue"),
    },
    {
      id: "language",
      attribute: t("scannerFingerprint.HTTP.contentLanguage"),
      ratio: 0.0,
      value: "-",
      clue: t("scannerFingerprint.HTTP.contentLanguageClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.HTTP.upgradeInsecureRequests"),
      ratio: 90.68,
      value: "1",
      clue: t("scannerFingerprint.HTTP.upgradeInsecureRequestsClue"),
    },
    {
      id: "doNotTrack",
      attribute: t("scannerFingerprint.HTTP.doNotTrack"),
      ratio: 65.05,
      value: "-",
      clue: t("scannerFingerprint.HTTP.doNotTrackClue"),
    },
  ];
};
